<template>
  <b-container>
    <b-col class="mt-2">
      <div>

        <b-row class="form-group">
          <b-col offset="9" md="3" align="right">
            <b-button class="clear" @click="clearFilterData()">
              {{ $t("label_advancedData_clearFilters") }}
            </b-button>
            <b-button variant="primary" @click="getConsolidatedData()">
              {{ $t("label_advancedData_applyFilters") }}
            </b-button>
          </b-col>
        </b-row>
        <template-filters ref="filters" />
        <b-container v-if="!getIsLoading">
          <b-row>
            <b-col cols="12" lg="12" md="12">
              <template-pillar-navigator-consolidated
                :pillar-id="currentPillarIdConsolidated"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6" md="6">
              <card-pillar-info-consolidated
                :pillar-id="currentPillarIdConsolidated"
                height="535px"
              />
            </b-col>
            <b-col cols="12" lg="6" md="6">
              <card-chart-radar-consolidated
                :key="refresh"
                :pillar-id="currentPillarIdConsolidated"
                alias="report"
                height="465px"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <card-chart-pillar-summary-consolidated
                :key="refresh"
                :pillar-id="currentPillarIdConsolidated"
                alias="report-radar"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="12" md="12">
              <card-conventions orientation="horizontal" />
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-col>
  </b-container>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import CardPillarInfoConsolidated from "./cards/CardPillarInfoConsolidated";
import CardChartRadarConsolidated from "./cards/CardChartRadarConsolidated";
import CardChartPillarSummaryConsolidated from "./cards/CardChartPillarSummaryConsolidated";

export default {
  name: "ReportsPillarConsolidatedPillar",
  components: {
    CardChartPillarSummaryConsolidated,
    CardChartRadarConsolidated,
    CardPillarInfoConsolidated,
  },
  data: function () {
    return {
      gauge: [],
      indicatorsData: [],
      currentIndicator: {},
      paramsPillar: "",
      refresh: 0,
    };
  },
  computed: mapGetters([
    "currentPillarIdConsolidated",
    "currentIndicatorIdConsolidated",
    "getIsLoading",
  ]),
  methods: {
    clearFilterData() {
      if (this.$refs.filters) {
        this.$refs.filters.clearFilters();
      }
      this.getConsolidatedData();
    },
    getConsolidatedData() {
      let parameters = {
        Companies: [],
        Tags: [],
        Years: [],
        Types: [],
        Locations: [],
        Sizes: [],
        Activities: [],
      };
      if (this.$refs.filters) {
        parameters = this.$refs.filters.getDataInFilters();
      }
      this.$store
        .dispatch("CONSOLIDATE_PILLARS_REPORT", parameters)
        .then(() => {
          this.setCurrentPillarIdConsolidated(this.$route.params.pillar);
        })
        .catch((err) => {
          console.log(err);
          //  this.$router.push('/home') // TODO Handle the error in a better way
        });
    },
    ...mapMutations([
      "setCurrentPillarIdConsolidated",
      "setCurrentIndicatorIdConsolidated",
    ]),
  },
  watch: {
    $route() {
      this.setCurrentPillarIdConsolidated(this.$route.params.pillar);
      this.refresh = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0;
          const v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
  },
  mounted() {
    this.getConsolidatedData();
  },
};
</script>

<style lang="sass" scoped>
h3
  font-size: 1.5rem
  margin-top: 40px

#ChartPillarContainer
  text-align: center

.col-5, .col-7
  padding-right: 5px
  padding-left: 5px
.col-8, .left
  padding-right: 5px
.col-4, .right
  padding-left: 5px
</style>
